import {BackgroundNotificationHandler} from './src/ExpoBackgroundNotificationHandlerModule'
export default BackgroundNotificationHandler
